import React from 'react'
import { any, fromJSX, Fun, Widget } from 'widgets-for-react'
import { CollectionsLoaderState } from '../../collections/collectionsLoader/collectionsLoaderState'
import { SharepointPageType } from '../sharepointPageWidget'
import { ButtonBlockLayout } from './block/buttonBlockLayout'
import { componentsBlockWidget } from './block/componentsBlock/componentsBlockWidget'
import { ExpandBlockLayout } from './block/expandBlockLayout'
import { ImageBlockLayout } from './block/imageBlockLayout'
import { QuoteBlockLayout } from './block/quoteBlockLayout'
import { TextBlockLayout } from './block/textBlockLayout'
import { TextWithImageBlockLayout } from './block/textWithImageBlockLayout'
import { BlocksLayout } from './blocksLayout'
import { Block, BlocksState, blocksStateUpdaters, TextBlock } from './blocksState'

export const blocksWidget =
  (
    collectionsState: CollectionsLoaderState,
    isLoggedIn: boolean,
    isPrintMode: boolean,
    pageType: SharepointPageType
  ) =>
  (blocksState: BlocksState) =>
    any<Fun<BlocksState, BlocksState & { reloadCollections?: boolean }>>(
      blocksState.blocks
        .map((block, index) =>
          blockSwitch(
            collectionsState,
            isLoggedIn,
            isPrintMode
          )(block).map(blocksStateUpdaters.blockUpdater(index))
        )
        .toArray()
    ).wrapHTML((element) => (
      <BlocksLayout pageType={pageType} children={element} />
    ))

const blockSwitch =
  (collectionsState: CollectionsLoaderState, isLoggedIn: boolean, isPrintMode: boolean) =>
  (
    block: Block
  ): Widget<Fun<Block, Block & { reloadCollections?: boolean }>> => {
    switch (block.kind) {
      case 'media':
        return fromJSX(() => <ImageBlockLayout {...block} />)
      case 'quote':
        return fromJSX(() => <QuoteBlockLayout {...block} />)
      case 'text':
        return fromJSX(() => <TextBlockLayout {...block} />)
      case 'component-grid':
        return componentsBlockWidget(
          collectionsState,
          isLoggedIn
        )(block).map(blocksStateUpdaters.componentsBlockUpdater)
      case 'button':
        return fromJSX(() => <ButtonBlockLayout {...block} />)
      case 'expandable_content':
        return fromJSX(() => <ExpandBlockLayout {...block} isPrintMode={isPrintMode} />)
      case 'text_with_image':
        return fromJSX(() => <TextWithImageBlockLayout {...block} />)
      default:
        return fromJSX(() => <></>)
    }
  }
